// extracted by mini-css-extract-plugin
module.exports = {"Icon":"contact_Icon__pFkRy","Card":"contact_Card__3_3aB","Main":"contact_Main__3mZ_i"};